import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {FiltersMobileButtonBox} from "../../../filters/filters-games-list-mobile/boxes/menu-button/filters-mobile-button.box";
import {FiltersMobileIconBox} from "../../../filters/filters-games-list-mobile/boxes/menu-button/filters-mobile-icon.box";
import {Link} from "../../../raw-components/link/link";
import React from "react";
import {FiltersGamesListMobileComponent} from "../../../filters/filters-games-list-mobile/filters-games-list-mobile.component";
import classNames from "classnames";
import {ACTIVE} from "../../../../themes/css-global-classes";
import {observer} from "mobx-react";

@observer
export class FiltersMobileButtonComponent extends OrbitComponent<{}> {

  private _openPopup = () => {
    this.services.dialog.showModal((dialogHandler) => <FiltersGamesListMobileComponent dialogHandler={dialogHandler}/>,{
      title: this.services.translation.translate('FILTER'),
      applyMaxHeight:true
    });
  };

  render(){
    if(this.services.gamesFilter.currentFilters.length === 0) {
      return null;
    }

    if(this.services.arenas.shouldHideFiltersButtonMobile()) {
      return null;
    }

    return (
    <Link box={FiltersMobileButtonBox} className={classNames('cy-filters-mobile-button', {[ACTIVE] : this.services.gamesFilter.isFilterOn})} onClick={this._openPopup}>
      <FiltersMobileIconBox className={'cy-filter-icon'}></FiltersMobileIconBox>
    </Link>
    )
  }
}